import { client } from '../client';
import { UserProfile } from './types/UserProfile';

/** PATCH /users/:user_id/unverified_email */
export const updateUnverifiedEmail = async (
  userId: number,
  payload: { unverified_email: string },
): Promise<UserProfile> => {
  const { data } = await client.patch<UserProfile>(`/users/${userId}/unverified_email`, payload);
  return data;
};

/** PATCH /users/:user_id/email (verified email change; backend may require extra verification). */
export const updateVerifiedEmail = async (userId: number, payload: { email: string }): Promise<UserProfile> => {
  const { data } = await client.patch<UserProfile>(`/users/${userId}/email`, payload);
  return data;
};
